import { render, staticRenderFns } from "./UserAccountChangePassword.vue?vue&type=template&id=1ee1d455&"
import script from "./UserAccountChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserAccountChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountChangePassword.vue?vue&type=style&index=0&id=1ee1d455&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports